<template>
	<article class="cp">
		<NuxtLink :to="item.url_without_domain" class="cp-top">
			<template v-if="item?.status != 3">
				<div class="cp-badge cp-badge-discount" v-if="item?.discount_percent_custom && item.discount_percent_custom > 0">%</div>
				<BaseCmsLabel code="badge_new" tag="div" class="cp-badge cp-badge-new" v-if="item?.priority_details?.code == 'new'" />
			</template>
			<figure class="cp-image"><BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width600-height600']" default="/images/no-image.jpg" :title="item.main_image_title" :alt="item.main_image_description || item.title" /></figure>

			<template v-if="item?.status != 3">
				<div class="cp-special-attribute" v-if="item.attributes_special && item.attributes_special[0].attribute_code == 'posebne_oznake' && mode != 'publish'">{{item.attributes_special[0].title}}</div>
			</template>
		</NuxtLink>
		<div class="cp-cnt">
			<div class="cp-cnt-main">
				<NuxtLink :to="item.category_url_without_domain" class="cp-category-title">{{item.category_title}}</NuxtLink>
				<NuxtLink :to="item.url_without_domain" class="cp-title">{{item.title}}</NuxtLink>
				<div class="cp-short-description" v-html="item.short_description" v-if="item.short_description" />
			</div>
			<div class="cp-cnt-bottom">
				<div class="price">
					<template v-if="item?.status != 3">
						<template v-if="item.price_custom > 0">
							<template v-if="item.discount_percent_custom > 0">
								<!--<div class="old-price"><BaseUtilsFormatCurrency :price="item.basic_price_custom" /></div>-->
								<div class="current-price red discount-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
								<div class="lowest-price">
									<template v-if="item.extra_price_lowest > 0 && item.basic_price > item.price_custom">
										<BaseCmsLabel code="lowest_price" />: <strong><BaseUtilsFormatCurrency :price="item.extra_price_lowest" /></strong>
									</template>
								</div>
							</template>
							<template v-else>
								<!--<div class="price-label"><BaseCmsLabel code="price" /></div>-->
								<div class="current-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
								<div class="lowest-price"></div>
							</template>
						</template>
					</template>
					<template v-else>
						<BaseCmsLabel code="price_on_request" class="current-price price-on-request" tag="div" />
						<div class="lowest-price"></div>
					</template>
				</div>
			</div>
		</div>

		<div class="footer" v-if="!mobileBreakpoint">
			<template v-if="!item.is_available">
				<NuxtLink :to="item.url_without_domain" class="btn btn-medium">
					<BaseCmsLabel code="view_details" />
				</NuxtLink>
			</template>
			<template v-else>
				<WebshopQty :quantity="item.quantity" :limit="item.available_quantity" :item="item" />
				<BaseWebshopAddToCart :data="{modalData: item, shopping_cart_code: item.shopping_cart_code, quantity: item.qty}" v-slot="{onAddToCart, loading}">
					<button :class="['btn btn-add noarrow btn-orange', {'loading': loading}]" @click="onAddToCart">
						<UiLoader v-if="loading" />
						<BaseCmsLabel code="add_to_shopping_cart" tag="span" />
					</button>
				</BaseWebshopAddToCart>
			</template>
		</div>
	</article>
</template>

<script setup>
	const props = defineProps(['item', 'mode']);
	const {mobileBreakpoint} = inject('rwd');
</script>

<style lang="less" scoped>
	.cp{
		position: relative; display: flex; flex-flow: column; width: calc(~"25% - 18px"); background: #fff; box-shadow: 0 10px 60px rgba(0,0,0,0.04); border-radius: 12px;
		@media (min-width: @h){
			&:hover{
				z-index: 2; box-shadow: 0 0 25px rgba(0,46,108,0.15);
				.footer{opacity: 1; visibility: visible;}
			}
		}	
		@media (max-width: @l){width: calc(~"25% - 13.5px");}
		@media (max-width: @t){width: calc(~"25% - 9px");}
		@media (max-width: @m){width: calc(~"50% - -1px"); margin: -1px 0 0 -1px; border: 1px solid var(--gray); border-radius: 0; box-shadow: none;}
	}
	.cp-top{
		position: relative; display: flex; align-items: center; flex-flow: column;
		@media (max-width: @m){align-items: flex-start; padding-top: 20px;}	
	}
	.cp-badge{
		position: absolute; top: 16px; width: auto; padding: 0 10px; height: 28px; display: flex; align-items: center; justify-content: center; background: #fff; border-radius: 3px; z-index: 1;
		@media (max-width: @m){top: 20px; height: 24px; padding: 0 7px;}
	}
	.cp-badge-discount{
		border: 1px solid var(--red); left: 20px; color: var(--red); font-size: 16px; line-height: 1;
		@media (max-width: @m){left: 16px;}	
	}
	.cp-badge-new{
		border: 1px solid var(--blue); color: var(--blue); right: 20px; font-size: 12px; line-height: 1; font-weight: 700; padding-top: 2px;
		@media (max-width: @m){right: 16px;}	
	}
	.cp-special-attribute{
		position: absolute; background: var(--blue); color: #fff; font-size: 12px; line-height: 14px; font-weight: 700; padding: 7px 10px; border-radius: 3px; bottom: -7px;
		@media (max-width: @m){bottom: 0; left: 16px; padding: 5px 8px;}	
	}
	.cp-image{
		position: relative; display: flex; align-items: center; justify-content: center; width: 100%; aspect-ratio: 1; border-radius: 12px 12px 0 0; overflow: hidden;
		:deep(img){max-width: 90%;}
		@media (max-width: @m){
			border-radius: 0;
			:deep(img){display: block; width: auto; height: auto; max-width: 96%;}
		}	
	}
	.cp-cnt{
		position: relative; display: flex; flex-flow: column; align-items: center; justify-content: space-between; gap: 20px; padding: 16px 40px 23px; flex-grow: 1; flex-shrink: 1;
		@media (max-width: @t){padding-bottom: 0;}
		@media (max-width: @m){padding: 10px 20px 20px; align-items: flex-start; gap: 10px;}	
	}
	.cp-cnt-main{
		display: flex; flex-flow: column; align-items: center;
		@media (max-width: @m){align-items: flex-start;}	
	}
	.cp-category-title{
		display: block; font-size: 14px; line-height: 1.42; text-decoration-color: transparent; font-weight: 700; color: var(--blue); margin-bottom: 5px; text-align: center; .transition(text-decoration-color);
		@media (min-width: @h){
			&:hover{text-decoration-color: var(--blue);}
		}	
		@media (max-width: @m){font-size: 12px; margin-bottom: 4px; text-align: left;}
	}
	.cp-title{
		display: block; font-size: 14px; line-height: 1.42; color: var(--textColor); text-decoration-color: transparent; text-align: center; transition: color 0.3s, text-decoration-color 0.3s;
		@media (min-width: @h){
			&:hover{text-decoration-color: var(--blue); color: var(--blue);}
		}
		@media (max-width: @m){text-align: left;}
	}
	.cp-short-description{
		position: relative; display: block; margin-top: 7px; text-align: center; font-size: 12px; line-height: 1.5; color: var(--darkGray);
		:deep(p){padding-bottom: 0;}
		@media (max-width: @t){font-size: 10px;}
		@media (max-width: @m){font-size: 11px; text-align: left;}
	}
	.current-price{
		display: block; font-size: 16px; line-height: 19px; font-weight: 700; text-align: center; margin-bottom: 2px;
		@media (max-width: @m){text-align: left;}
	}
	.price-on-request{font-size: 14px;}
	.lowest-price{
		display: block; text-align: center; font-size: 10px; line-height: 12px; color: var(--darkGray); min-height: 12px;
		@media (max-width: @l){max-width: 140px; min-height: 24px;}
		@media (max-width: @m){
			text-align: left;
			&:empty{display: none;}
		}
	}
	.footer{
		position: absolute; top: 100%; left: 0; right: 0; display: flex; align-items: flex-start; justify-content: center; padding: 0 14px 14px; gap: 8px; margin-top: -9px; background: #fff; box-shadow: 0 34px 40px rgba(0,46,108,0.10); border-radius: 0 0 12px 12px; opacity: 0; visibility: hidden; .transition(opacity,visibility);
		@media (max-width: @t){position: relative; top: auto; opacity: 1; visibility: visible; box-shadow: none; margin: 0; padding: 5px 16px 23px;}	
	}
	.btn-add{
		font-size: 0; padding: 0; width: 48px; height: 48px; gap: 0;
		&:before{.icon-cart(); font: 24px/1 var(--fonti); color: #fff;}
		&.loading{
			&:before{display: none;}
		}
	}
</style>